import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import {
  Grid,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';

// Shared components
import {
  CommonPanel,
} from 'components';

// Component styles
import styles from './styles';

class NtkMaterialPicker extends Component {
  state = {
    selectedMaterials: [],
  }

  onChange({ target }) {
    const { handleChange } = this.props;
    const [ type, value ] = target.value.split('|');
    const { selectedMaterials } = this.state;
    const existing = _.find(selectedMaterials, { type });

    if (target.checked) {
      // Add to selection

      if (existing) {
        // Type was already selected
        existing.values = [...existing.values, value];
      } else {
        // Type wasn't selected yet
        selectedMaterials.push({ type, values: [value] });
      }
    } else {
      // Remove from selection

      _.remove(existing.values, val => val === value);
      _.remove(selectedMaterials, material => material.values.length === 0);
    }

    this.setState({
      selectedMaterials,
    });

    handleChange({
      name: 'materials',
      value: selectedMaterials,
    });
  }

  renderMaterials() {
    const { classes, materials, initialMaterials, recordMaterials } = this.props;
    
    return _.map(initialMaterials, ({ type, values }) => {
      
      // Collect material options (combine type with value for actual control value)
      const checkboxes = _.map(values, (value) => {
        // Disable all unchecked inputs if there's no available materials left
        // otherwise disable inputs by material availability
        const material = _.find(materials.length ? materials : recordMaterials, { type });
        const disabled = material ? material.values.indexOf(value) === -1 : true;

        return (
          <FormControlLabel
            className={classes.material}
            key={value}
            control={<Checkbox onChange={this.onChange.bind(this)} value={[type, value].join('|')} />}
            label={value}
            disabled={disabled}
          />
        );
      });

      // Render material column with options
      return (
        <Grid
          key={type}
          item
          sm={3}
        >
          <FormControl component="fieldset">
            <FormLabel component="legend">{type}</FormLabel>
            <FormGroup>
              {checkboxes}
            </FormGroup>
          </FormControl>
        </Grid>
      )
    })
  }

  render() {
    const { t } = this.props;

    return (
      <CommonPanel
        title={t('Statinio parametrai')}
      >   
        <Grid container>
          {this.renderMaterials()}
        </Grid>
      </CommonPanel>
    );
  }
}

export default compose(withStyles(styles), withTranslation())(NtkMaterialPicker);
